import { Modal } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import _, { get, isString as lodashString } from 'lodash';
import moment, { Moment } from 'moment';
import { AddressFieldType, MediaType } from 'src/types/common/common';
import { v4 as uuidv4 } from 'uuid';
import { AllTypes } from '../types/common/common';
import { getUserInfo } from './getUserInfo';
const ERROR_VAR_END_5 = 'Error';
const ERROR_TIP_END_5 = '__TIP';
const LAST_ERROR_NUMBER = -5;
export { AllTypes };
export {
  timeTransform,
  getStateTarget,
  formatDate1,
  collapseEditorWillUnMount,
  formatLocaleSalesChannel,
  convertRes2Blob,
  getParameter,
  networkSuccessCb,
  setHasModified,
  getFileExt,
  getFieldFromTrans,
  addressFormat,
  //getCurrentLanguage,
  copyToClip,
  formGetValue,
  onFinishFailed,
  calculateCountryAreasText,
  generalFilterOptions,
  dataURI2Blob,
  mediaTypeCheck,
  nameTrans,
  firstUpperCase,
  formatPrice,
  titleGenerator,
};
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);

export const generalSort = (name1, name2) => {
  const n1 = name1.toLowerCase();
  const n2 = name2.toLowerCase();
  if (n1 > n2) return 1;
  if (n2 > n1) return -1;
  return 0;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showWarning = (message: string, okCb: any) => {
  Modal.warning({
    title: 'Warning',
    content: message,
    onOk: okCb,
  });
};
export const isInteger = (value) => {
  return value % 1 === 0;
};
export const isNumberOrString = (value) => {
  return (
    instanceType(value) === AllTypes.Number ||
    instanceType(value) === AllTypes.String
  );
};
export const isNumber = (value) => {
  return instanceType(value) === AllTypes.Number;
};
export const isArray = (value) => {
  return instanceType(value) === AllTypes.Array;
};
export const isString = (value) => {
  return instanceType(value) === AllTypes.String;
};
export const isObject = (value) => {
  return instanceType(value) === AllTypes.Object;
};
export const instanceType = (ins) => {
  return Object.prototype.toString.call(ins).split(' ')[1].replace(']', '');
};
export const hasValue = (target) => {
  const isInvalid =
    instanceType(target) === AllTypes.Null ||
    instanceType(target) === AllTypes.Undefined;
  return !isInvalid;
};
export const i18n = (intl, keyword: string[]) => {
  if (!intl || !keyword || keyword.length === 0) {
    return '';
  }
  const { messages } = intl;
  let res = messages;
  while (keyword.length > 0) {
    if (instanceType(res) === AllTypes.Object) {
      const key = keyword.shift();
      res = res[key];
    } else {
      res = '';
      break;
    }
  }
  return res;
};
export const controlSymbolFilter = (str) => {
  if (str) {
    return str.replace(
      //'删除为了适配输入法
      /[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g,
      //`~!#$%^&*()+=<>?:"{}|,\/;\\[\]·~！#￥%……&*（）——+={}|《》？：“”【】、；‘’，。、
      '',
    );
  } else {
    return str;
  }
};

export const letterFilter = (str) => {
  if (str) {
    const reg = /[a-zA-Z]/g;
    return str.replace(reg, '');
  } else {
    return str;
  }
};

export const numberFilter = (str) => {
  if (str) {
    const reg = /[^0-9.]/g;
    return str.replace(reg, '');
  } else {
    return str;
  }
};

export const sweetControlSymbolFilter = (str) => {
  if (str) {
    return str.replace(
      /[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F《》？：“”【】、；‘’，。、]/g,
      '',
    );
  } else {
    return str;
  }
};

export const randomNumber = () => {
  return uuidv4(); //Math.random().toString(36).slice(-10);
};

export const addDraggableId = (data) => {
  if (data) {
    const _data = (data || []).map((i) => {
      const { draggableId } = i;
      if (!draggableId) {
        return { ...i, draggableId: randomNumber() };
      }
      return i;
    });
    //console.log('_data', _data);
    return _data;
  }
  return data;
};

export const clearError = (obj = {}) => {
  return {
    ...obj,
    ...Object.keys(obj).reduce((pre, now = '') => {
      const temp = {};
      if (now.slice(LAST_ERROR_NUMBER) !== ERROR_VAR_END_5) {
        temp[generateErrorKey(now)] = false;
        //return { ...pre, [generateErrorKey(now)]: false };
      }
      return { ...pre, ...temp };
    }, {}),
  };
};
// export const clearError2 = (state,obj = {}) => {

//   // return {
//   //   ...obj,
//   //   ...Object.keys(obj).reduce((pre, now = '') => {
//   //     if (now.slice(LAST_ERROR_NUMBER) !== ERROR_VAR_END_5) {
//   //       return { ...pre, [generateErrorKey(now)]: false };
//   //     } else {
//   //       return { ...pre };
//   //     }
//   //   }, {}),
//   // };
// };
export const generateErrorKey = (key: string) => {
  //return `_${key}Error`
  return `${key}${ERROR_VAR_END_5}`;
};
export const generateErrorTip = (key: string) => {
  //return `_${key}Error`
  return `${key}${ERROR_TIP_END_5}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getError = (
  key: string,
  data: { [propName: string]: any } = {},
) => {
  const _k = generateErrorKey(key);
  return data[_k];
};
export const getErrorTip = (
  key: string,
  data: { [propName: string]: any } = {},
) => {
  const _k = generateErrorTip(key);
  return data[_k];
};
export const reduxDefaultStatusControl = {
  hasModified: false,
  dataValid: false,
  loaded: false,
};
export const reduxUpdatedStatusControl = {
  hasModified: false,
  dataValid: false,
  loaded: true,
  lastSubmitStamp: randomNumber(),
};

export const searchConditions = {
  search: [],
  filter: {},
  sort: {},
  tableSettings: [],
};
export const scroll = (id, disableOffset?) => {
  const ele = window.document.getElementById(id);
  if (!ele) return;
  ele.scrollIntoView({ block: 'center', behavior: 'smooth' });
  // const root = document.getElementById('root');
  // root.scrollTo(0, 0);
  // if (!disableOffset) {
  //   window.scrollBy();
  // }
};
export const timeoutScroll = (id) => {
  const ele = window.document.getElementById(id);
  if (!ele) return;
  return _.delay(() => {
    ele.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, 100);
};
// export const timeoutScroll = (id) => {
//   const ref = React.useRef<any>(null);
//   const ele = window.document.getElementById(id);
//   if (!ele) return;
//   React.useEffect(() => {
//     ref.current = setTimeout(() => {
//       ele.scrollIntoView({ block: 'center', behavior: 'smooth' });
//     }, 100);
//     return () => {
//       if (ref.current) {
//         clearTimeout(ref.current);
//       }
//     };
//   }, []);
// };
export const scrollSmooth = (id) => {
  const element = document.getElementById(id);

  if (!element) {
    return;
  }
  const offset = 160;
  if (element) {
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};
export function subStringNum(a, num) {
  //a=原本的数字，num=要取几位小数，
  const a_type = typeof a;
  let aArr = [];
  if (a_type == 'number') {
    const aStr = a.toString();
    aArr = aStr.split('.');
  } else if (a_type == 'string') {
    aArr = a.split('.');
  }

  if (aArr.length > 1) {
    a = aArr[0] + '.' + aArr[1].substr(0, num);
  }
  return a;
}
export function formatNumber(number, decimalSeparatorNumber?) {
  if (instanceType(number) === AllTypes.Number) {
    return number.toFixed(decimalSeparatorNumber || 2);
  } else {
    return number;
  }
}

export function formatMoney(number) {
  if (instanceType(number) === AllTypes.Number) {
    return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  } else {
    return number;
  }
}

export function unique(arr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      if (arr[i].toLowerCase() == arr[j].toLowerCase()) {
        //第一个等同于第二个，splice方法删除第二个
        arr.splice(j, 1);
        j--;
      }
    }
  }
  return arr;
}

export function getImageWidthNHeight(url: string) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      resolve({ width: image.width, height: image.height });
    };
    image.onerror = (e) => {
      reject(e);
    };
  });
}

export function getClientTimeZone() {
  return 'GMT ' + '+' + (0 - new Date().getTimezoneOffset() / 60);
}

export function nameCopy(target: string, copys: string[], count = 0): string {
  if (copys.includes(target)) {
    if (!/\s?Copy(\s\d|\s+)?$/.test(target)) {
      // 不包含 Copy
      // 重置为 name Copy
      target = target + ' Copy';
      count--;
    } else if (count === 0) {
      // 重置为 name
      target = target.replace(/\s?Copy(\s\d|\s+)?$/, '');
    } else {
      // 重置为 name Copy n
      target = target.replace(/\s?Copy(\s\d|\s+)?$/, ` Copy ${count}`);
    }
    count++;
    return nameCopy(target, copys, count);
  }
  return target;
}

export const transSizeToKB = (size: number) => {
  return Number(size) ? `${(size / 1024).toFixed(2)} KB` : '';
};

export const uuid = () => {
  const s = [];
  const hexDigits = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  const uuid = s.join('');
  return uuid;
};

export const scrollIntoView = (id: string) => {
  const ele: Element = document.getElementById(id);
  if (ele) ele.scrollIntoView();
};

export const mapRightAnchorName = (name: string) => {
  return `${name}-panel`;
};

export const mapLeftAnchorName = (name: string) => {
  return `${name}-preview`;
};

export const sizeConvert = (bytes) => {
  return bytes;
};

export function assData(state, data = {}) {
  Object.keys(data).forEach((i) => {
    state[i] = data[i];
  });
}

export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
}

export const groupSortingByTime = (settingList = []) => {
  let inUse = [];
  let pending = [];
  let previous = [];
  const currentTime = moment();
  settingList.forEach((setting) => {
    const {
      startTime,
      endTime,
      hasError,
    }: { hasError?: boolean; startTime: Moment; endTime: Moment } =
      setting || {};
    if (!startTime || !endTime) {
      pending.push(setting);
    } else {
      if (currentTime.isBetween(startTime, endTime)) {
        if (hasError) {
          pending.push(setting);
        } else {
          inUse.push(setting);
        }
      }
      if (currentTime.isAfter(endTime)) previous.push(setting);
      if (currentTime.isBefore(startTime)) pending.push(setting);
    }
  });
  inUse = sorByAscentTime(inUse);
  pending = sorByAscentTime(pending);
  previous = sortByDecentTime(previous);
  return {
    inUse,
    pending,
    previous,
  };
};
const sortByDecentTime = (list: Array<{ startTime: string }>) => {
  return list.sort((item1, item2) => {
    if (!item1.startTime) return 1;
    if (!item2.startTime) return 1;
    if (moment(item1.startTime).isAfter(item2.startTime)) return -1;
    return 0;
  });
};

const sorByAscentTime = (list: Array<{ startTime: string }>) => {
  return list.sort((item1, item2) => {
    if (!item1.startTime) return 1;
    if (!item2.startTime) return 1;
    if (moment(item1.startTime).isBefore(item2.startTime)) return -1;
    return 0;
  });
};
const timeTransform = (t: string) => {
  const m = moment(t);
  const date = t ? m.format('YYYY-MM-DD') : '';
  const time = t ? m.format('H:m') : '';
  return { date, time };
};
const getStateTarget = (state, reducers) => {
  return _.get(state, reducers || [], null);
};

const formatDate1 = (string) => {
  if (string) {
    return moment(string).format('DD MMM YY, HH:mm');
  }
  return string;
};

const getFileExt = (name: string) => {
  const reg = /\.[^\.]+$/;
  const matches = reg.exec(name);
  if (matches) {
    return matches[0].replace('.', '');
  }
  return '';
};

const collapseEditorWillUnMount = ({ state, defaultState }) => {
  if (state.timeoutRef) {
    state.timeoutRef.forEach((i) => {
      try {
        clearTimeout(i);
      } catch (e) {}
    });
  }
  assData(state, defaultState);
};
const sortLocales = (locales = []) => {
  return _.sortBy(locales, (c) => {
    return c.locale;
  });
};

const formatLocaleSalesChannel = ({ channels, localeSupply = {} }) => {
  const mappedByUuid = channels.reduce((pre, channel) => {
    const {
      uuid,
      name,
      channelType,

      timezone,
      timezoneGmt,

      status,
      availableLanguages,
      primaryLanguage,
    } = channel;
    const languageList = availableLanguages.map((i) => {
      const isPrimary = i === primaryLanguage;
      const locale = i;
      return { locale, isPrimary, ...localeSupply };
    });
    if (pre[uuid]) {
      (pre[uuid].locales || []).push(...languageList);
      sortLocales(pre[uuid].locales);
    } else {
      pre[uuid] = {
        name,
        uuid,
        channelType,
        timezone,
        timezoneGmt,
        status,
        locales: languageList,
      };
    }
    return pre;
  }, {});

  const r = Object.values(mappedByUuid);
  return r;
};

function dataURI2Blob(base64Data) {
  let byteString;
  let mimeString = 'image/jpeg';
  if (base64Data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(base64Data.split(',')[1]);
  } else {
    byteString = unescape(base64Data.split(',')[1]);
    mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
  }
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
}

function convertRes2Blob(response) {
  // 提取文件名

  const gName = (name) => {
    return _.replace(name, /"/g, '');
  };

  const fileName = response.headers['content-disposition']
    ? gName(response.headers['content-disposition'].match(/filename=(.*)/)[1])
    : //.replaceAll('"', '')
      'Export file';

  // 将二进制流转为blob
  const blob = new Blob([response.data], { type: 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(fileName));
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob);
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', decodeURI(fileName));
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }
    // 挂载a标签
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL);
  }
}
const getParameter = (name) => {
  const url = new URL(window.location.href);
  const search = get(url, 'search');
  const params = new URLSearchParams(search);
  return params.get(name);
};

const networkSuccessCb = (event) => {
  window.dispatchEvent(new Event(event));
};

const setHasModified = (state) => {
  state.hasModified = true;
};

/**
 *
 *
 * @param {*} locale -  /portal/salesChannelSetting/languageSetting/translation  接口获取到的语言包信息 { locale:'' , categories:[] }
 * @param {*} name - 获取 name 对应的路径
 *
 * @returns pathList 路径数组 ,可以通过 _.get(locale,pathItem) 获取到对应的对象
 */
const getFieldFromTrans = (locale, name) => {
  const pathList = [];
  const categories = locale.categories;
  for (let a = 0; a < categories.length; a++) {
    if (categories[a].name === name) {
      pathList.push(`categories[${a}]`);
    }
    const subCategories = categories[a].subCategories;

    for (let b = 0; b < subCategories.length; b++) {
      if (subCategories[b].name === name) {
        pathList.push(`categories[${a}].subCategories[${b}]`);
      }

      const keys = subCategories[b].keys || [];

      for (let c = 0; c < keys.length; c++) {
        if (keys[c].name === name) {
          pathList.push(`categories[${a}].subCategories[${b}].keys[${c}]`);
        }
      }
    }
  }
  return pathList;
};

/**
 * 复制内容到粘贴板
 * content : 需要复制的内容
 * message : 复制完后的提示，不传则默认提示"复制成功"
 */
const copyToClip = (content) => {
  const aux = document.createElement('input');
  aux.setAttribute('value', content);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand('copy');
  document.body.removeChild(aux);
};

const formGetValue = (target, namePath) => {
  let ret = null;
  namePath.forEach((i) => {
    ret = get(target, i);
  });
  return ret;
};

const onFinishFailed = (formName, data) => {
  //
  // console.log(formName, data);
  const { errorFields } = data;
  const pre = formName + '_';

  if (errorFields[0]) {
    const first = (errorFields[0] || {}).name || [];
    const suf = first.join('_');
    const id = pre + suf;
    timeoutScroll(id);
  }
};

const calculateCountryAreasText = (countryItem, countries) => {
  const length = (
    countries.filter(
      (country) => country.country.code === countryItem.country.code,
    )[0]?.subdivisions || []
  ).length;
  const { subdivisions = [] } = countryItem;
  const sub =
    subdivisions && length !== (subdivisions || []).length
      ? `(${(subdivisions || []).length} of ${length} provinces:${(
          subdivisions || []
        )
          .map((item) => item.name)
          .join(',')})`
      : '';
  return sub;
};

const generalFilterOptions = (input, option) =>
  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const mediaTypeCheck = (media) => {
  const contentType = get(media, 'contentType') || '';

  if ((contentType || '').startsWith('image')) {
    return MediaType.Image;
  }
  if ((contentType || '').startsWith('video')) {
    return MediaType.Video;
  }
  return null;
};

export const btoa = function (str: string) {
  const b64 =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let bitmap,
    a,
    b,
    c,
    result = '',
    i = 0;
  const string = String(str);
  const rest = string.length % 3; // To determine the final padding

  for (; i < string.length; ) {
    if (
      (a = string.charCodeAt(i++)) > 255 ||
      (b = string.charCodeAt(i++)) > 255 ||
      (c = string.charCodeAt(i++)) > 255
    )
      throw new TypeError(
        "Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.",
      );

    bitmap = (a << 16) | (b << 8) | c;
    result +=
      b64.charAt((bitmap >> 18) & 63) +
      b64.charAt((bitmap >> 12) & 63) +
      b64.charAt((bitmap >> 6) & 63) +
      b64.charAt(bitmap & 63);
  }

  // If there's need of padding, replace the last 'A's with equal signs
  return rest ? result.slice(0, rest - 3) + '==='.substring(rest) : result;
};

const nameTrans = (fullNameAutoPopulate, firstName, lastName, fullName) => {
  const { firstNameFirst = false, separator = '' } = fullNameAutoPopulate;
  const separatorList = { ['Space']: ' ', ['NotUse']: '', ['Comma']: ', ' };

  if (fullName) {
    return fullName;
  }
  let nameArray = [];
  if (firstNameFirst) {
    nameArray = [firstName, lastName];
  } else {
    nameArray = [lastName, firstName];
  }
  return nameArray.join(separatorList[separator]);
};

const addressFormat = (format, address) => {
  if (format == null || address == null) {
    return null;
  }
  const fields = [];
  for (const field of format) {
    switch (field.fieldType) {
      case AddressFieldType.City:
        if (address.cityVO.name) {
          fields.push(address.cityVO.name);
        }
        break;
      case AddressFieldType.Postcode:
        if (address.postalCode) {
          fields.push(address.postalCode);
        }
        break;
      case AddressFieldType.Subdivision:
        if (address.provinceVO.name) {
          fields.push(address.provinceVO.name);
        }
        break;
      case AddressFieldType.AddressLine1:
        if (address.address) {
          fields.push(address.address);
        }
        break;
      case AddressFieldType.AddressLine2:
        if (address.address2) {
          fields.push(address.address2);
        }
        break;
    }
  }
  return fields.join(' ');
};

//字符串首字母转大写
const firstUpperCase = (str) => {
  return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
};
//格式化金额，加,号
const formatPrice = (
  str: string | number,
  thousandsSeparator,
  decimalSeparator,
) => {
  let s = str.toLocaleString().replaceAll('.', `#`);
  s = s.replaceAll('#', decimalSeparator);
  const pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(s)) {
    s = s.replace(pattern, `$1${thousandsSeparator}$2`);
  }
  return s;
  // console.log('str', str);
  // const strTranslation = //Number(str || 0)
  //   str.toLocaleString().replaceAll('.', `#`);
  // const res = strTranslation
  //   .replaceAll(',', thousandsSeparator)
  //   .replaceAll('#', decimalSeparator);
  // console.log('strTranslation', strTranslation);
  // console.log('res', res);
};

export function thousandsSeparator(
  n: string | number,
  thousandsSeparator,
  decimalSeparator,
): string {
  const strSplit = n.toString().split('.');
  const integer = strSplit[0].split('');
  integer.reverse();
  const decimal = strSplit[1];
  const newInteger = [];
  for (let i = 0; i < integer.length; i++) {
    if (i % 3 === 0 && i !== 0) {
      newInteger.push(thousandsSeparator);
    }
    newInteger.push(integer[i]);
  }
  newInteger.reverse();
  let s = newInteger.join('');
  if (decimal) {
    s += `${decimalSeparator}${decimal}`;
  }
  return s;
}

export const generatorAuth = () => {
  const userInfo = getUserInfo();
  return `Basic ${btoa(
    `${get(userInfo, 'userUuid')}:${get(userInfo, 'token')}`,
  )}`;
};

export function isURL(str) {
  const expression =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  const regex = new RegExp(expression);
  return regex.test(str || '');
}

export function isHttpsURL(str) {
  const expression =
    /^(https:\/\/www\.|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
  const regex = new RegExp(expression);
  return regex.test(str || '');
}

const titleGenerator = (title) => {
  if (lodashString(title)) {
    return title;
  }
  try {
    return get(title, 'props.name');
  } catch (e) {
    return '';
  }
};
export const formatTimeBySetting = (config) => {
  return `${(config?.dateFormat || '').toUpperCase() || 'DD/MM/YYYY'} ${
    config?.timeFormat || 'HH:mm'
  }`;
};

// const navigateToProduct = (uuid: string, type: any) => {
//   if (type === 'Simple') {
//     history.push(`/product/simpleProduct/${uuid}`);
//   } else if (type === 'Set') {
//     history.push(`/product/productSet/${uuid}`);
//   } else {
//     history.push(`/product/virtualProduct/${uuid}`);
//   }
// };
export const add0 = (num: number) => {
  return num < 10 ? '0' + num : '' + num;
};
// startDate: 开始时间；dayLength：每隔几天，0-代表获取每天，1-代表日期间隔一天
export const getTargetDate = (date: string, dayLength = 0) => {
  dayLength = dayLength + 1;
  const tempDate = new Date(date);
  tempDate.setDate(tempDate.getDate() + dayLength);
  const year = tempDate.getFullYear();
  const month = add0(tempDate.getMonth() + 1);
  const day = add0(tempDate.getDate());
  return year + '-' + month + '-' + day;
};

export const getCustomizesDate = (
  startDate: string,
  endDate: string,
  customizes: any[],
): string[] => {
  const disableDateOfWeek = customizes.reduce(
    (p: number[], c: any, index: number) => {
      if (c.checked) {
        return p;
      }
      return p.concat(index + 1);
    },
    [],
  );
  const dayLength = 0;
  const arr = disableDateOfWeek.includes(dayjs(startDate).isoWeekday())
    ? [startDate]
    : [];
  for (let i = 0; ; i++) {
    const getDate = getTargetDate(startDate, dayLength);
    startDate = getDate;
    if (getDate <= endDate) {
      if (disableDateOfWeek.includes(dayjs(getDate).isoWeekday())) {
        arr.push(getDate);
      }
    } else {
      break;
    }
  }
  return arr;
};

export const getAllRangeDate = (
  startDate: string,
  endDate: string,
): string[] => {
  const dayLength = 0;
  const arr = [startDate];
  for (let i = 0; ; i++) {
    const getDate = getTargetDate(startDate, dayLength);
    startDate = getDate;
    if (getDate <= endDate) {
      arr.push(getDate);
    } else {
      break;
    }
  }
  return arr;
};

export function calcDisableRange({
  selectableDates,
  blockOutDates = [],
  customizes,
  format,
}: any): string[] {
  // TODO: 可选日期没有结束日期的问题
  if (!selectableDates?.length) {
    return [];
  }
  const _startDate = dayjs(selectableDates[0], format).format('YYYY-MM-DD');
  const _endDate = selectableDates[1]
    ? dayjs(selectableDates[1], format).format('YYYY-MM-DD')
    : dayjs(selectableDates[0], format).add(31, 'd').format('YYYY-MM-DD');
  const allBlockOutDates: string[] = (blockOutDates || []).reduce(
    (p: string[], c: string[]) => {
      // const __startDate = dayjs(c[0], format).format('YYYY-MM-DD');
      // const __endDate = dayjs(c[1], format).format('YYYY-MM-DD');
      const __startDate = dayjs(c[0], 'YYYY-MM-DD').format('YYYY-MM-DD');
      const __endDate = dayjs(c[1], 'YYYY-MM-DD').format('YYYY-MM-DD');
      return p.concat(getAllRangeDate(__startDate, __endDate));
    },
    [],
  );
  const allCustomizeBlockDates: string[] =
    getCustomizesDate(_startDate, _endDate, customizes) || [];

  return Array.from(
    new Set(allBlockOutDates.concat(allCustomizeBlockDates)),
  ).sort((a, b) => (a > b ? 1 : -1));
}

export function addEndSeconds(end: any) {
  return end.add(59, 'seconds');
}

/**
 * 扁平数据转换为嵌套结构对象
 * 用于给定的字段名，例如将 { USD: 12 } 转为 { USD: { price: 12 } }
 *
 * @param raw - 原始的币种金额对象（如 { USD: 100, EUR: 200 }）
 * @param key - 用于包装的字段名（如 'price'、'discount' 等）
 * @returns 包装后的对象（如 { USD: { price: 100 }, EUR: { price: 200 } }）
 */
export function wrapPriceObject<T extends string>(
  raw: Record<T, number> | undefined,
  key: string,
): Record<T, { [K in typeof key]: number }> {
  const result = {} as Record<T, { [K in typeof key]: number }>;
  if (!raw) return result;

  Object.entries(raw).forEach(([currency, amount]) => {
    result[currency as T] = {
      [key]: Number(amount),
    } as { [K in typeof key]: number };
  });

  return result;
}

/**
 * 嵌套结构扁平化
 * 提取指定字段的数值，例如将 { USD: { price: 12 } } 转为 { USD: 12 }
 *
 * @param raw - 原始嵌套结构对象（如 { USD: { price: 100 }, EUR: { price: 200 } }）
 * @param key - 要提取的字段名（如 'price'）
 * @returns 扁平化后的对象（如 { USD: 100, EUR: 200 }）
 */
export function transformPriceObject<T extends string, K extends string>(
  raw: Record<T, Record<K, number>> | undefined,
  key: K,
): Record<T, number> {
  const result: Record<T, number> = {} as Record<T, number>;
  if (!raw) return result;

  Object.entries(raw).forEach(([currency, obj]) => {
    result[currency as T] = obj[key] as number;
  });

  return result;
}

type PriceTierInput = {
  uuid: string;
  title: string;
  [key: string]: any;
};

type MatchedInput = {
  priceTierUuid?: string;
  [key: string]: any;
};
export function buildGroupedPriceSettings(
  priceTiers: PriceTierInput[],
  matchData?: MatchedInput[],
): any[] {
  const titleGroupMap = new Map<string, any[]>();

  (priceTiers || []).forEach((tier) => {
    const { uuid, title, ...rest } = tier;

    let base: any = {
      priceTierUuid: uuid,
      title,
      key: randomNumber(),
    };

    if (matchData) {
      const match = matchData.find((o) => o.priceTierUuid === uuid);
      if (!match) return;
      base = {
        ...match,
        priceTierUuid: uuid,
        title,
        key: randomNumber(),
      };
    } else {
      base = {
        ...rest,
        ...base,
      };
    }

    let group = titleGroupMap.get(title);
    if (!group) {
      group = [];
      titleGroupMap.set(title, group);
    }
    group.push(base);
  });

  let groupIndex = 1;
  const result: any[] = [];

  for (const group of titleGroupMap.values()) {
    group.forEach((item, idx) => {
      item.displayIndex = `${groupIndex}-${idx + 1}`;
      result.push(item);
    });
    groupIndex++;
  }

  return result;
}
